import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgClose = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.38249 2.17975L3.46323 2.25105L8 6.78714L12.5368 2.25105C12.8715 1.91632 13.4142 1.91632 13.7489 2.25105C14.0579 2.56004 14.0817 3.04624 13.8203 3.38249L13.7489 3.46323L9.212 8L13.7489 12.5368C14.0837 12.8715 14.0837 13.4142 13.7489 13.7489C13.44 14.0579 12.9538 14.0817 12.6175 13.8203L12.5368 13.7489L8 9.212L3.46323 13.7489C3.1285 14.0837 2.58579 14.0837 2.25105 13.7489C1.94207 13.44 1.9183 12.9538 2.17975 12.6175L2.25105 12.5368L6.78714 8L2.25105 3.46323C1.91632 3.1285 1.91632 2.58579 2.25105 2.25105C2.53429 1.96781 2.96643 1.92424 3.29549 2.12033L3.38249 2.17975Z"
          fill="currentColor"
        />
      </svg>
    </IconBase>
  );
};

SvgClose.displayName = 'SvgClose';
export default SvgClose;
